import script from "./NoticiasCard.vue?vue&type=script&setup=true&lang=js"
export * from "./NoticiasCard.vue?vue&type=script&setup=true&lang=js"

import "./NoticiasCard.vue?vue&type=style&index=0&id=34ac8d34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34ac8d34"]])

export default __exports__